<template>

  <div class="dingdan">
    <Breadtabsheader/>
    <div class="h-piece h-mrt30 margin">
      <div class="h-formBox">
        <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder" ref="form">
          <div class="h-thirdColumn w-newColumn">
            <el-form-item label="用户单位关键字" prop="deptName">
              <el-input v-model="formInline.keyWords" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="  渠道" prop="channelCode">
              <brselectlazy category="channel_classification" :v="formInline.channelCode" v-model="formInline.channelCode"
                            :clearable="true"
                            style="width:100%"/>
            </el-form-item>
            <el-form-item label="用户分类" prop="userUnit">
              <el-input v-model="formInline.userUnit" placeholder="请输入"></el-input>
            </el-form-item>
          </div>
        </el-form>
        <div class="l-screenBox">
          <div class="l-retrieval">
            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
            </el-button>
            <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus"
                       @click="createKeywords()">
              新建用户单位关键字
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="h-table h-mrt30 tableclslist">
      <el-table
          ref="ddtable"
          :data="tableData"
          stripe
          border
          :show-overflow-tooltip="true"
          style="width: 100%"
          max-height="450"
      >
        <el-table-column
            type="index"
            width="40"
            label="#"
            fixed
        >
        </el-table-column>
        <el-table-column
            fixed
            prop="keyWords"
            label="用户单位关键字"
            :show-overflow-tooltip="true"
            width="200">
        </el-table-column>
        <el-table-column
            prop="priority"
            label="优先级"
            :show-overflow-tooltip="true"
            width="100">
        </el-table-column>
        <el-table-column
            prop="channelCode"
            label="渠道编码"
            :show-overflow-tooltip="true"
            width="110">
        </el-table-column>
        <el-table-column
            prop="channelName"
            label="渠道"
            :show-overflow-tooltip="true"
            width="110">
        </el-table-column>
        <el-table-column
            prop="userUnitCode"
            label="用户分类编码"
            width="110">
        </el-table-column>
        <el-table-column
            prop="userUnit"
            label="用户分类"
            width="110">
        </el-table-column>
        <el-table-column
            prop="suffix"
            label="用户单位后缀"
            width="110">
        </el-table-column>
        <el-table-column
            prop="cuname"
            label="创建人"
            :show-overflow-tooltip="true"
            width="120">
        </el-table-column>
        <el-table-column
            prop="cdate"
            label="创建时间"
            :show-overflow-tooltip="true"
            :formatter="formatDate"
            width="120">
        </el-table-column>
        <el-table-column
            fixed="right"
            label="操作"
            width="150"
        >
          <template slot-scope="scope">
            <div style="text-align: left;">
              <div style="text-align: left;">
                <el-button
                    size="small" class="h-tableLink h-btn"
                    @click="updateKeywords(scope.row.id)">修改
                </el-button>
                <el-button size="small" class="h-tableLink h-btn"
                           @click="deleteKeywords(scope.row.id)">
                  删除
                </el-button>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
        <pagination :page="formInline" @query="query"/>
      </div>
      <el-dialog :close-on-click-modal="false"  @close='closeDialog' :visible.sync="newDialog" class="h-dialog2">
        <div class="h-dialogImg">
          <div class="h-disTable">
            <div class="h-tableCell">
              <h1>{{titleDig}}</h1>
            </div>
          </div>
        </div>
        <div class="h-formLines">
          <el-form ref="form" :model="add" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">
            <el-form-item label="关键字" class="h-elformWrap-2" prop="keyWords" :rules="[{ required: true, message: '请输入关键字', trigger: 'blur'},]">
              <el-input v-model="add.keyWords" style="width: 84%;" placeholder="请输入关键字"></el-input>
            </el-form-item>
            <el-form-item label="优先级" class="h-elformWrap-2" prop="priority">
              <el-input v-model="add.priority" @blur="validateInteger" style="width: 84%;" placeholder="请输入数字"></el-input>
            </el-form-item>
            <el-form-item  label="渠道" class="h-elformWrap-2" label-width="100" prop="channelCode" :rules="[{ required: true, message: '请选择渠道', trigger: 'blur'},]">
              <brselectlazy category="channel_classification" :v="add.channelCode" :showcode="true" @change="changeChannel($event)"
                             v-model="add.channelCode"
                             :clearable="true"/>
            </el-form-item>
            <el-form-item  label="用户分类" class="h-elformWrap-2" label-width="100" prop="userUnitCode" :rules="[{ required: true, message: '请选择用户分类', trigger: 'change'},]">
              <el-select v-model="add.userUnitCode" :v="add.userUnitCode" :rules="[{ required: true, message: '请输入用户分类', trigger: 'change'},]"
                         @change="changeSchoolType($event)"  placeholder="请选择" clearable>
                <el-option v-for="item in addressTypeList"
                           :key="item.id"
                           :label="item.userUnit"
                           :value="item.userUnitCode">
                </el-option>
              </el-select>
            </el-form-item>
            <h5 style="color: red;font-size: 0.14rem;margin-top: 0.1rem;margin-left: 50px">多个后缀请使用/隔离</h5>
            <el-form-item label="单位后缀" class="h-elformWrap-2" prop="suffix">
              <el-input v-model="add.suffix" style="width: 84%;"></el-input>
            </el-form-item>
          </el-form>
          <div style="display:flex;justify-content:center;margin-bottom:20px">
            <el-button class="h-btn h-bBtn h-bgwhite" @click="exit">取消</el-button>
            <el-button class="h-btn h-bBtn h-bgblueQ2" @click="saveKeywords">提交</el-button>
          </div>
        </div>
      </el-dialog>
      <el-dialog :close-on-click-modal="false"  @close='closeDialog' :visible.sync="updateDialog" class="h-dialog2">
        <div class="h-dialogImg">
          <div class="h-disTable">
            <div class="h-tableCell">
              <h1>{{uptitleDig}}</h1>
            </div>
          </div>
        </div>
        <div class="h-formLines">
          <el-form ref="form" :model="add" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">
            <el-form-item label="关键字" class="h-elformWrap-2" prop="keyWords">
              <el-input v-model="add.keyWords" style="width: 84%;"></el-input>
            </el-form-item>
            <el-form-item label="优先级" class="h-elformWrap-2" prop="priority">
              <el-input v-model="add.priority" @blur="validateInteger" style="width: 84%;" placeholder="请输入数字"></el-input>
            </el-form-item>
            <el-form-item  label="渠道" class="h-elformWrap-2" label-width="100" prop="channelCode" :rules="[{ required: true, message: '请选择渠道', trigger: 'blur'},]">
              <brselectlazy category="channel_classification" :v="add.channelCode" :showcode="true" @change="changeChannel($event)"
                             v-model="add.channelCode"
                             :clearable="true"/>
            </el-form-item>
            <el-form-item  label="用户分类" class="h-elformWrap-2" label-width="100" prop="userUnitCode" :rules="[{ required: true, message: '请选择用户分类', trigger: 'change'},]">
              <el-select v-model="add.userUnitCode" :v="add.userUnitCode" :rules="[{ required: true, message: '请输入用户分类', trigger: 'change'},]"
                         @change="changeSchoolType($event)"  placeholder="请选择" clearable>
                <el-option v-for="item in addressTypeList"
                           :key="item.id"
                           :label="item.userUnit"
                           :value="item.userUnitCode">
                </el-option>
              </el-select>
            </el-form-item>
            <h5 style="color: red;font-size: 0.14rem;margin-top: 0.1rem;margin-left: 50px">多个后缀请使用/隔离</h5>
            <el-form-item label="单位后缀" class="h-elformWrap-2" prop="suffix">
              <el-input v-model="add.suffix" style="width: 84%;"></el-input>
            </el-form-item>
          </el-form>
          <div style="display:flex;justify-content:center;margin-bottom:20px">
            <el-button class="h-btn h-bBtn h-bgwhite" @click="exit">取消</el-button>
            <el-button class="h-btn h-bBtn h-bgblueQ2" @click="saveKeywords">提交</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>

import ss from '../../api/SystemService'
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
export default {
  components:{
    Treeselect
  },
  data() {
    return {
      tableData: [],
      //表单
      formInline: {
        pageSize: 10,
        pageNo: 1,
        total: 0,
        keyWords: '',
        channelCode: '',
        userUnitCode: '',
        userUnit: '',
      },
      //新增
      add: {
        id: '',
        keyWords: '',
        channelCode: '',
        channelName: '',
        userUnitCode: '',
        userUnit: '',
        version:'2',//逻辑版本，历史为1，当前为2
        priority:null,//优先级
        suffix:null,//单位后缀
      },
      addressTypeList:[],
      newDialog:false,
      updateDialog:false,
      titleDig:'',
      uptitleDig:'',
    }
  },
  created() {
    this.query();
  },
  methods: {
    handleFilter() {
      this.formInline.pageNo = 1;
      this.query();
    },
    query(){
      ss.nxAddressKeywords.select2Page(this.formInline).then(rd => {
        this.formInline.total = rd.total;
        this.tableData = rd.records;
      });
    },
    // 重置按钮
    resetData() {
      this.formInline.keyWords = "";
      this.formInline.userUnit = "";
      this.formInline.channelCode = "";
      this.formInline.pageSize = 10;
      this.formInline.pageNo = 1;
      this.query();
    },
    //单条查询
    updateKeywords(id){
      ss.nxAddressKeywords.selectById(id).then(rd => {
        this.add = rd.msg;
        this.updateDialog = true;
        this.uptitleDig = '修改关键字';
        console.log('1231231231',this.add);
        ss.nxAddress.getAddressTypeByChannel2(this.add.channelCode).then(rd =>{
          this.addressTypeList = rd.msg;
          this.add.userUnit = '';
        })
      })
    },
    //新增
    createKeywords(v){
      this.titleDig = "新建用户单位关键字"
      this.newDialog = true
    },
    //取消
    exit() {
      this.closeDialog()
    },
    //关闭弹窗,清空数据
    closeDialog(){
      this.newDialog = false
      this.updateDialog = false
      //清空数据
      this.add.id = '';
      this.add.keyWords = '';
      this.add.channelCode = '';
      this.add.userUnitCode = '';
      this.add.version = '2';//逻辑版本，历史为1，当前为2
      this.add.priority = null;//优先级
      this.add.suffix = null;//单位后缀
    },
    validateInteger() {
      if (null != this.add.priority && '' != this.add.priority){
        const regex = /^[1-9]\d*$/;
        if (!regex.test(this.add.priority)){
          alert("请输入正确的数字","提示");
        }
      }
    },
    //渠道改变
    changeChannel(value){
      console.log("value",value)
      ss.nxAddress.getAddressTypeByChannel2(value.code).then(rd =>{
        this.addressTypeList = rd.msg;
        this.add.userUnit = '';
        this.add.userUnitCode = '';
      })
    },
    changeSchoolType(value){
      this.add.userUnit = value;
    },
    //时间日期格式化
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property]
      if(data == null) {
        return null
      }
      let dt = new Date(data)
      return this.$util.riQi3(dt);
    },
    saveKeywords(){
      if (null != this.add.priority && '' != this.add.priority){
        const regex = /^[1-9]\d*$/;
        if (!regex.test(this.add.priority)){
          alert("请输入正确的优先级数字","提示");
          return;
        }
      }
      //新增
      ss.nxAddressKeywords.insertKeywords(this.add).then(rd=>{
        this.closeDialog();
        this.query();
      })
    },
    deleteKeywords(val){
      //删除数据
      ss.nxAddressKeywords.deleteById(val).then(rd=>{
        this.query();
      })
    }
  },
}
</script>

<style scoped>
.xiangmu .h-piece, .h-mrt30 {
  margin: 20px;
}

.h-formBtnOut .h-mr20 {
  margin-left: 1rem !important;
}

.D-date .el-cascader {
  line-height: 0;
}
.tableclslist	.h-tableLink{
  padding:0px 2px!important;
}
</style>
<style>
.dz-date .h-dialogForm .h-elformWrap-2{
  width: 50%!important;
  padding-right: 0
}
.dz-date .h-elformWrap-2 .el-form-item__label{
  width: 33%!important;
}
.dz-date .h-elformWrap-2 .el-form-item__content{
  width: 62%!important;
}
.h-formbLine.qlplshyj .h-elformWrap-1 .el-form-item__label{
  width: 20%;
}
.h-formbLine.qlplshyj .h-elformWrap-1 .el-form-item__content{
  width: 80%;
}
</style>
